// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import store from './store'
import '../node_modules/bootstrap/dist/js/bootstrap.min'
import HomeHelpContent from './components/home/help/HomeHelpContent.vue'
import HomeHelp from './components/home/help/HomeHelp.vue'
import HomeJoinUsContent from './components/home/join_us/HomeJoinContent.vue'
import HomeContent from './components/home/strength_intro/HomeContent.vue'
import HomeFirmIntro from './components/home/firm_intro/HomeFirmIntro.vue'
import HomeJoinUs from './components/home/join_us/HomeJoinUs.vue'
import HomeContact from './components/home/contact/HomeContact.vue'
import HomeApp from './components/home/app/HomeApp.vue'
import App from './App'
import HomeMortgageContent from './components/home/service_intro/mortgage/HomeMortgageContent.vue'
import HomeReplaceContent from './components/home/service_intro/replace/HomeReplaceContent.vue'
import HomeLoanContent from './components/home/service_intro/loan/HomeLoanContent.vue'
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.http.options.emulateJSON = true
const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'homeContent',
      component: HomeContent
    },
    {
      path: '/firm-intro',
      name: 'homeFirmIntro',
      component: HomeFirmIntro
    },
    {
      path: '/join-us',
      name: 'homeJoinUs',
      component: HomeJoinUs,
      children: [{
        path: 'market',
        name: 'market',
        component: HomeJoinUsContent
      },
      {
        path: 'research',
        name: 'research',
        component: require('components/home/join_us/HomeJoinResearch')
      },
      {
        path: 'opearte',
        name: 'opearte',
        component: require('components/home/join_us/HomeJoinOperate')
      },
      {
        path: 'preduce',
        name: 'preduce',
        component: require('components/home/join_us/HomeJoinPreduce')
      },
      {
        path: 'administration',
        name: 'administration',
        component: require('components/home/join_us/HomeJoinAdministration')
      },
      {
        path: 'personnel',
        name: 'personnel',
        component: require('components/home/join_us/HomeJoinPersonnel')
      }]
    },
    {
      path: '/contact',
      name: 'homeContact',
      component: HomeContact
    },
    {
      path: '/app',
      name: 'homeApp',
      component: HomeApp
    },
    {
      path: '/help',
      name: 'homeHelp',
      component: HomeHelp,
      children: [{
        path: 'basic',
        name: 'basic',
        component: HomeHelpContent
      }]
    },
    {
      path: '/mortgage',
      name: 'homeMortgageContent',
      component: HomeMortgageContent
    },
    {
      path: '/replace',
      name: 'homeReplaceContent',
      component: HomeReplaceContent
    },
    {
      path: '/loan',
      name: 'homeLoanContent',
      component: HomeLoanContent
    }
  ]
})
/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js